import React, {useEffect, useState} from "react";
import {Alert, Container} from "@mui/material";
import {Navigate, useNavigate, useSearchParams} from "react-router-dom";
import {determineLocation} from "./assets/determineLocation";
import Loading from "./components/loading";

export default function FilingRedirect() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState("");
    const token = params.get("d");

    useEffect(() => {
        if (!token) return;
        const controller = new AbortController();
        setError("");
        fetch(`${determineLocation()}/filing/reinstatement/options?d=${encodeURIComponent(token)}`, {signal: controller.signal})
            .then(async response => {
                const body = await response.json();
                if (!response.ok) throw new Error(body.message || "Unable to verify this company.");
                const route = body.message.state.lifecycleStatus === "active" ? "/renew" : "/reinstate";
                navigate(`${route}?d=${encodeURIComponent(token)}`, {replace: true});
            })
            .catch(reason => {
                if (!controller.signal.aborted) setError(reason.message);
            });
        return () => controller.abort();
    }, [token, navigate]);

    if (!token) return <Navigate to="/reinstate" replace/>;
    return error ? <Container sx={{py: 5}}><Alert severity="error">{error}</Alert></Container> : <Loading/>;
}
